import React from 'react';
import { IntlProvider } from 'react-intl';
import { ApiHandlerProvider } from '@dnb/api-handler';
import { DynamicRoutingProvider } from '@dnb/dynamic-routing';
import Head from '@dnb/helmet';
import { getLang } from '@dnb/locale';
import { getIntlConfig } from '@pm-netbank/services';
import { translations } from '@pm-netbank/translations';
import OddFormProvider from '../providers/OddFormProvider';

/**
 * In the PageElementWrapper you will receive all the dynamic path parameters
 * as described in the /pages folder structure, where any folder or file
 * called `[paramName].js` would result in `paramName` being passed to this
 * function as a dynamic parameter.
 *
 * NB: `paramName` is case sensitive.
 *
 * These parameters will then be passed to the routing provider and used to
 * determine which component to render.
 * If a new dynamic path parameter is added under /pages, it only needs to be
 * added here and it will be available to you from components using the
 * RoutingContext.
 *
 * See the RoutingProvider for more information.
 *
 * This is being used in gatsby-browser.js and gatsby-ssr.js to render this
 * application.
 */
export function PageElementWrapper({ children, params }) {
  return (
    <DynamicRoutingProvider parameters={params}>
      <Head>
        <title>Become a user</title>
      </Head>

      <IntlProvider {...getIntlConfig(translations, getLang())}>
        <ApiHandlerProvider appErrors={{}}>
          <OddFormProvider>{children}</OddFormProvider>
        </ApiHandlerProvider>
      </IntlProvider>
    </DynamicRoutingProvider>
  );
}
